/// <reference path="../../../typings/tsd.d.ts" /> 
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var FormGridModalController = /** @class */ (function (_super) {
            __extends(FormGridModalController, _super);
            function FormGridModalController(scope, formSection, processConfigurationId, close, formService, treeService, schemaPropertyService) {
                var _this = _super.call(this, scope, close) || this;
                _this.formService = formService;
                _this.treeService = treeService;
                _this.schemaPropertyService = schemaPropertyService;
                var self = _this;
                _this.scope = scope;
                _this.scope.formSection = formSection;
                _this.scope.processConfigurationId = processConfigurationId;
                _this.scope.includedFormIds = [formSection.form_id];
                _this.scope.addColumn = function () { return _this.addColumn(); };
                _this.scope.onDropTreeItem = function (e, column) { return _this.onDropTreeItem(e, column); };
                _this.scope.isSaveDisabled = function () { return _this.isSaveDisabled(); };
                return _this;
            }
            FormGridModalController.prototype.isSaveDisabled = function () {
                return !Enumerable.from(this.scope.formSection.columns).all(function (c) { return c.schemaProperty != null; });
            };
            FormGridModalController.prototype.onDropTreeItem = function ($event, column) {
                var ti = this.treeService.getTreeConfigurationItem();
                this.schemaPropertyService.getSchemaProperty(ti.schemaPropertyId).then(function (prop) {
                    column.schemaProperty = prop;
                });
            };
            FormGridModalController.prototype.addColumn = function () {
                var column = this.formService.createFormGridColumn(this.scope.formSection);
                column.position = this.scope.formSection.columns.length;
                this.scope.formSection.columns.push(column);
                //this.formService.saveAllChanges();
            };
            return FormGridModalController;
        }(controllers.BaseModalController));
        controllers.FormGridModalController = FormGridModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('FormGridModalController', ['$scope', 'formSection', 'processConfigurationId', 'close', 'formService', 'treeService', 'schemaPropertyService']);
